import { autobind } from 'core-decorators';
import PropTypes from 'prop-types';
/* eslint-disable max-len */
import React, { Component, Fragment } from 'react';
import FixedEnvironmentTable from './fixed';

@autobind
export default class CornDensityTable extends Component {
    static propTypes = {
        user: PropTypes.object,
        environmentType: PropTypes.oneOf(['fixed', 'variable']).isRequired,
    };

    render() {
        const sharedProps = {
            user: this.props.user,
            cropConfig: this.props.cropConfig,
            fieldLimits: this.props.fieldLimits,
            productRecommendations: this.props.productRecommendations,
            selectedProductRecommendation: this.props.selectedProductRecommendation,
            status: this.props.status,
        };

        return (
            <Fragment>
                {this.props.environmentType === 'fixed' && (
                    <FixedEnvironmentTable
                        {...sharedProps}
                        onProductToggle={this.props.onProductToggle}
                        userDensity={this.props.userDensity}
                        onUserDensityChange={this.props.onUserDensityChange}
                        userNitrogen={this.props.userNitrogen}
                        onUserNitrogenChange={this.props.onUserNitrogenChange}
                    />
                )}
            </Fragment>
        );
    }
}
